import { actionCopyEs } from "./actionCopy";

export const diaryCopyEs = {
    diaries: "Diarios",
    diary: "Diario",
    diaryPeriod: "Periodo del diario",
    toDo: "Pendiente",
    results: "Resultados",
    toNow: "- Hoy",
    edit: actionCopyEs.edit,
    change: "Modificar",
    details: "Detalles",
    deleteEntry: "Eliminar el registro",
    done: actionCopyEs.done,
    next: actionCopyEs.next,
    save: actionCopyEs.save,
    saving: actionCopyEs.saving,
    cancel: actionCopyEs.cancel,
    date: "Fecha",
    time: "Hora",
    noSteps: "Ningún paso.",
    step: "Paso",
    chooseStep: "Elegir un paso",
    currently: "Actualmente",
    general: "General",
    procedureDetails: "Detalles de la intervención",
    hospitalReferenceNumber: "Número de historia clínica",
    hospitalNumber: "Número de historia clínica",
    hospitalNumberDescription: "Número de historia clínica para todos los seguimientos.",
    enterHospitalNumber: "Introducir el número de historia clínica",
    startDate: "Fecha de inicio",
    procedureDate: "Fecha de la intervención",
    referenceDate: "Fecha de referencia",
    referenceDateDescription: "La fecha de la inyección, de la cirugía o de otra intervención.",
    baselineDate: "Fecha basal",
    baselineDateDescription:
        "La fecha desde la que se mide el seguimiento, por ejemplo, cuando el paciente se incorporó al estudio. Los cuestionarios se programan a partir de esta fecha.",
    patientBaselineDate: "Fecha de inicio",
    patientBaselineDateDescription: "La fecha a partir de la que se programan sus preguntas de seguimiento.",
    eventDateDescription: "Los cuestionarios de seguimiento se programan a partir de esta fecha.",
    patientEventDateDescription: "Sus preguntas de seguimiento se programan a partir de esta fecha.",
    endDate: "Fecha de fin",
    contactPerson: "Persona de contacto",
    contactPersonDescription:
        "Contacto principal de este diario. Pulse Copiar para copiar su dirección de correo electrónico.",
    loadingContact: "Cargando el contacto...",
    side: "Lado",
    anatomicArea: "Área anatómica",
    questionnaireSide: "Lado del cuestionario",
    questionnaireSideDescription: "El lado al que se refiere este cuestionario.",
    notSet: "Sin definir",
    trackerSettings: "Ajustes del seguimiento",
    consent: "Consentimiento",
    consentForm: "Formulario de consentimiento",
    consentDetails: "Detalles",
    sign: "Firmar",
    signed: "Firmado",
    signedAt: (date) => `Firmado el ${date}`,
    requiresSignature: "Firma requerida",
    actionRequiredSignConsent: "Acción requerida: firmar el consentimiento",
    signConsentBeforeContinuing: (count) =>
        `Debe firmar ${count > 1 ? "los siguientes formularios de consentimiento" : "el siguiente formulario de consentimiento"} antes de continuar:`,
    signConsentNow: "Firmar el consentimiento ahora",
    detailsStillNeed: "Información aún necesaria",
    detailsStillNeedDescription:
        "Complete esta información. Si aún falta el lado, se lo preguntaremos en la pantalla de configuración.",
    injectionSide: "Lado de la inyección",
    injectionAnatomicArea: "Área anatómica de la inyección",
    surgerySide: "Lado de la cirugía",
    shockwaveSide: "Lado de las ondas de choque",
    shockwaveAnatomicArea: "Área anatómica de las ondas de choque",
    yourEntries: "Sus registros",
    noDiary: "Ningún diario",
    noCompletedEntries: "Ningún registro completado por el momento.",
    form: "formulario",
    forms: "formularios",
    item: "elemento",
    items: "elementos",
    questionnaire: "Cuestionario",
    questionnaires: "Cuestionarios",
    injection: "Inyección",
    surgery: "Cirugía",
    shockwave: "Ondas de choque",
    consultation: "Consulta",
    procedure: "Intervención",
    procedures: (count) => `${count} intervenciones`,
    task: "tarea",
    tasks: "tareas",
    toDoEmpty: "Está al día - no hay nada pendiente por el momento.",
    blocked: "En espera de los formularios anteriores",
    blockedEmpty: "Ningún formulario está a la espera de pasos anteriores.",
    formsLockedUntilConsentSigned: "Sus formularios se desbloquearán tras firmar el consentimiento requerido.",
    completePreviousFormFirst: (formName) => `Complete primero ${formName}`,
    doneEmpty: "Los pasos completados aparecerán aquí.",
    complete: "Completado",
    due: "Pendiente",
    upToDate: "Al día",
    allCaughtUp: "Todo al día",
    formsNeedAttention: "Formularios por atender",
    progress: "Progreso",
    completed: "Completado",
    notNeeded: "No necesario",
    dueNow: "Pendiente ahora",
    waiting: "En espera",
    locked: "Bloqueado",
    lockedByEarlierEntry: "Bloqueado - complete primero un registro anterior",
    lockedUntilPreviousFormComplete: (formName) => `Bloqueado - complete primero ${formName}`,
    availableLater: "Disponible más tarde",
    nextDue: "Próximo plazo",
    dueOn: (date) => `Pendiente el ${date}`,
    nextScheduledSentence: (formLabel, scheduleLabel, date) => {
        const schedule = scheduleLabel.trim();
        const due = date.trim();
        const timing = schedule ? ` para ${schedule.toLowerCase()}` : "";
        if (due) return `Su ${formLabel}${timing} debe cumplimentarse el ${due}.`;
        return `Su ${formLabel}${timing} debe cumplimentarse en breve.`;
    },
    noEntriesScheduled: "Ningún registro planificado por el momento.",
    showLess: "Mostrar menos",
    showMore: (count) => `Mostrar más (${count} ${count === 1 ? "plazo" : "plazos"} más)`,
    showAllTimings: (count) => `Mostrar los ${count} plazos`,
    expand: "Ampliar",
    submitted: (completed, total) => `${completed} de ${total} enviados`,
    submittedOn: (date) => `Enviado el ${date}`,
    noDataYet: "Ningún dato por el momento",
    noDataDescription: "Empiece a añadir registros para ver su evolución a lo largo del tiempo",
    notEnoughDataYet: "Datos aún insuficientes",
    notEnoughDataDescription: "Para mostrar los gráficos se necesitan al menos dos registros.",
    addEntry: "Añadir un registro",
    addEntryFor: (formSlug, timingLabel) => `Añadir un registro ${formSlug} ${timingLabel}`,
    addExtraScore: "Añadir una puntuación adicional",
    addExtraScoreTitle: "Añadir una puntuación adicional",
    addExtraScoreDescription:
        "Este paso es opcional. Continúe solo si desea registrar una medición adicional, o si se le ha pedido una actualización.",
    addForm: "Añadir un formulario",
    entryDue: (label) => `Su registro para ${label.toLowerCase()} debe cumplimentarse.`,
    nextEntryDueOn: (label, date) => `Su registro « ${label.toLowerCase()} » debe cumplimentarse el ${date}.`,
    entriesDueForForm: (count) => `${count} registros por cumplimentar para este formulario.`,
    formWithEntriesDue: (formName, entries) =>
        `${formName} tiene ${entries} ${entries === 1 ? "registro por cumplimentar" : "registros por cumplimentar"}. El resto de sus formularios están al día.`,
    formsWithEntriesDue: (forms, entries) =>
        `Tiene ${forms} ${forms === 1 ? "formulario" : "formularios"} con ${entries} ${
            entries === 1 ? "registro por cumplimentar" : "registros por cumplimentar"
        }.`,
    allFormsComplete: "Todos sus formularios están completados.",
    allEntriesComplete: "Todos los registros están completadas",
    entriesDueNow: (count) => `${count} registros por cumplimentar ahora`,
    completeYourEntry: (label) => `Complete su registro « ${label.toLowerCase()} »`,
    questionnaireDueNow: "Cuestionario por cumplimentar ahora",
    nextEntryLabel: (label) => `Próximo registro: ${label}`,
    waitingForNextEntry: "En espera de la próximo registro",
    readyLabel: (label) => `Listo: ${label}`,
    readyToComplete: "Listo para cumplimentar",
    reminderText: "Le enviaremos un SMS cuando esté pendiente.",
    reminderEmail: "Le enviaremos un correo electrónico cuando esté pendiente.",
    reminderTextAndEmail: "Le enviaremos un SMS y un correo electrónico cuando esté pendiente.",
    reminderNone:
        "Active los recordatorios por SMS o correo electrónico en sus ajustes si desea un recordatorio en el momento oportuno.",
    entrySubmitted: "Registro transmitido.",
    completeWithCareTeam: "Completado y pendiente de valoración.",
    formNumber: (index) => `Formulario n.º ${index}`,
    dateOfProcedure: (phrase) => `Fecha de la intervención (${phrase})`,
    wrongDate: "¿Fecha incorrecta?",
    editHere: "Modificar aquí",
    showAnswers: "Mostrar las respuestas",
    hideAnswers: "Ocultar las respuestas",
    showAnswersDescription: "Consulte las respuestas o pulse Modificar en un plazo para actualizar las respuestas",
    entryCountLabel: (count) => (count === 1 ? "1 registro" : `${count} registros`),
    timing: "Plazo",
    referredBy: (name) => `Derivado por: ${name}`,
    performedBy: (name) => `Realizado por: ${name}`,
    method: (method) => `Método: ${method}`,
    injectionDetails: "Información sobre la inyección",
    unknown: "Desconocido",
    noDateSpecified: "Ninguna fecha indicada",
    noInjectionDetails: "No se ha facilitado información sobre la inyección.",
    sideNotSpecified: "Lado no especificado",
    areaNotSpecified: "Área no especificada",
    siteNotSpecified: "Localización no especificada",
    substanceNotSpecified: "Sustancia no especificada",
    blankAnswer: "Dejado en blanco",
    listEmptyTitle: "Ningún diario por el momento",
    listEmptyDescription: "Los diarios creados para usted aparecen aquí",
    listCheckAgain: "Comprobar de nuevo",
    listNeedsAttention: "Requiere su atención",
    listNeedsAttentionDescription: "Diarios cuyos formularios esperan su próximo registro.",
    listOngoing: "En curso",
    listOngoingDescription: "Diarios en curso o a la espera de su primer registro.",
    listUpToDateDescription: "Diarios en curso sin registros por cumplimentar por el momento.",
    listNoOngoing: "Ningún diario en curso por el momento",
    listCompletedDescription: "Diarios completados (que ya no recogen registros).",
    listNoCompleted: "Ningún diario completado por el momento",
    listOpenDiary: "Abrir el diario",
    listReviewDiary: "Consultar el diario",
};
